import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { trace, context, Context, Span, SpanStatusCode } from '@opentelemetry/api';

@Injectable({ providedIn: 'root' })
export class TracingService {
  private tracer = trace.getTracer('angular-router');
  private activeNavSpan: Span | undefined;
  private activeNavContext: Context | undefined;

  constructor(private router: Router) {
    this.init();
  }

  private init() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const span = this.tracer.startSpan('route-change', {
          attributes: {
            'http.route': event.url,
            'app.route': event.url,
          },
        });
        this.activeNavSpan = span;
        // Make the span active in context so LoggerService and downstream work can access it
        this.activeNavContext = trace.setSpan(context.active(), span);
      } else if (event instanceof NavigationEnd) {
        if (this.activeNavSpan) {
          this.activeNavSpan.setAttribute('http.route', event.urlAfterRedirects);
          this.activeNavSpan.setAttribute('app.route', event.urlAfterRedirects);
          this.activeNavSpan.end();
          this.activeNavSpan = undefined;
          this.activeNavContext = undefined;
        }
      } else if (event instanceof NavigationError) {
        if (this.activeNavSpan) {
          this.activeNavSpan.recordException(event.error);
          this.activeNavSpan.setStatus({ code: SpanStatusCode.ERROR, message: String(event.error) });
          this.activeNavSpan.end();
          this.activeNavSpan = undefined;
          this.activeNavContext = undefined;
        }
      } else if (event instanceof NavigationCancel) {
        if (this.activeNavSpan) {
          this.activeNavSpan.setAttribute('navigation.cancelled', true);
          this.activeNavSpan.setStatus({ code: SpanStatusCode.ERROR, message: event.reason });
          this.activeNavSpan.end();
          this.activeNavSpan = undefined;
          this.activeNavContext = undefined;
        }
      }
    });
  }

  /** Returns the current active navigation context, if any. */
  getActiveContext() {
    return this.activeNavContext ?? context.active();
  }
}